import 'font-awesome/css/font-awesome.min.css';
import 'moment/locale/ja';
import 'moment/locale/ko';
import 'moment/locale/zh-cn';
import './icons.css';

import * as Sentry from '@sentry/react';

import ErrorBoundary from '~/components/Util/ErrorBoundary';
import ProtectSecurityContainer from '~/containers/protect-security-container/ProtectSecurityContainer';
import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';

import BaseStyles from './BaseStyles';
import NotificationWrapper from './components/NotificationWrapper/NotificationWrapper';
import Pages from './Pages';
import * as serviceWorker from './serviceWorkerRegistration';
import environment from './stores/providers/environment';
import theme from './theme';

if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    integrations: [],
    tracesSampleRate: 1.0,
    beforeSend(event) {
      if (event.level !== 'fatal') {
        return null;
      }

      return event;
    },
  });
}

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <BaseStyles />
        <NotificationWrapper />
        <ProtectSecurityContainer />
        <Pages />
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
